import config from '@feature-config/core/health/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { HealthFeature } from './HealthFeature';

const healthFeature: FeatureModule = createFeatureModule(
  config,
  HealthFeature,
  'core/health'
);

export default healthFeature;
